import script from "./TechnicalAssistanceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalAssistanceForm.vue?vue&type=script&setup=true&lang=js"

import "./TechnicalAssistanceForm.vue?vue&type=style&index=0&id=35103454&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35103454"]])

export default __exports__